<template>
  <div class="job-resources">
    <div class="team">
      <div class="users">
        <label>MANAGER</label>
        <ul>
          <li v-for="(user_id) in JOB.manager_ids" :key="user_id">
            <a href="javascript:;" class="avatar" v-tooltip="allStaff[user_id].full_name">{{ allStaff[user_id].initials }}</a>
          </li>
        </ul>
      </div>
      <div class="users">
        <label>TEAM MEMBERS</label>
        <ul>
          <li v-for="(user_id) in JOB.member_ids" :key="user_id">
            <a href="javascript:;" class="avatar" v-tooltip="allStaff[user_id].full_name">{{ allStaff[user_id].initials }}</a>
          </li>
          <li><a href="javascript:;" class="avatar btn-add" v-tooltip="'Add member'" @click="showModalTeam">+</a></li>
        </ul>
      </div>
    </div>
    <div class="time">
      <ul class="total">
        <li>TOTAL TIME SPENT</li>
        <li>{{ JOB.duration | numberFormat}}{{ IS_SUPER_ADMIN && JOB.expected_duration?' / ' + JOB.expected_duration:'' }} HOURS </li>
      </ul>
      <button class="btn btn-outline-black" @click="showModalAddTimesheet = true">+ Add Time</button>
    </div>
    <modal-add-time v-model="showModalAddTimesheet" @timesheet-saved="onTimesheetAdded"></modal-add-time>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import ModalAddTime from './ModalAddTime.vue';
import ModalEditTeam from './ModalEditTeam.vue';

export default {
  components: {
    ModalAddTime
  },
  data () {
    return {
      showModalAddTimesheet: false
    }
  },
  watch: {},
  computed: {
    ...mapGetters(['JOB', 'IS_SUPER_ADMIN']),
    ...mapState({
      allStaff: state => state.option.usersWithKey
    })
  },
  created () {},
  mounted () {
    this.init();
  },
  methods: {
    init () {
      this.showModalAddTimesheet = false;
    },
    showModalTeam () {
      let self = this;

      self.$modal.show(ModalEditTeam, {
      }, {
        clickToClose: false,
        width: 592
      });
    },
    onTimesheetAdded ( ) {
      this.showModalAddTimesheet = false;
      this.$store.dispatch('GET_JOB', this.JOB.id);
    },
  }
}
</script>
